export default __webpack_public_path__ + "static/media/deathlessacolytemagus.149d349e.png";